import {Typography} from "@bolteu/clay-react";

import {useI18n} from "i18n/i18n";

import inboxLogo from "assets/inbox_3D.png";

import * as Styled from "./formSubmitted.styled";

export const FormSubmitted = () => {
    const i18n = useI18n();
    return (
        <Styled.Container>
            <img src={inboxLogo} alt="Inbox" width={119} height={88} />
            <Typography defaultTag="h2" className="bolt-font-heading-xs-accent pt-6">
                {i18n("webform.form_submitted.title")}
            </Typography>
            <Typography className="bolt-font-body-l-regular pt-2">{i18n("webform.form_submitted.subtitle")}</Typography>
        </Styled.Container>
    );
};
